import React from 'react';
import { 
  IonButton, 
  IonHeader, 
  IonTitle, 
  IonToolbar, 
  IonContent,
  IonModal,
  IonIcon
} from '@ionic/react';
import { Box, Typography } from '@mui/joy';
import { warningOutline, timeOutline, refreshOutline, logOutOutline } from 'ionicons/icons';
import './SessionWarningModal.css';

const SessionWarningModal = ({ 
  isOpen, 
  timeLeft, 
  formatTimeLeft, 
  onExtendSession, 
  onForceLogout,
  onClose 
}) => {
  
  // Listener para extender sesión con cualquier click mientras el modal está abierto
  React.useEffect(() => {
    if (!isOpen) return;
    const handleAnyClick = (e) => {
      // Solo extender si el modal está abierto
      if (isOpen) {
        onExtendSession();
      }
    };
    document.addEventListener('mousedown', handleAnyClick);
    document.addEventListener('touchstart', handleAnyClick);
    return () => {
      document.removeEventListener('mousedown', handleAnyClick);
      document.removeEventListener('touchstart', handleAnyClick);
    };
  }, [isOpen, onExtendSession]);

  return (
    <IonModal 
      isOpen={isOpen} 
      backdropDismiss={false}
      className="session-warning-modal"
    >
      <IonHeader>
        <IonToolbar color="warning">
          <IonTitle>
            <Box display="flex" alignItems="center" gap={1}>
              <IonIcon icon={warningOutline} />
              Haz click para mantener la sesión abierta.
            </Box>
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      
      <IonContent className="session-warning-content">
        <Box className="warning-container">
          {/* Icono principal */}
          <Box className="warning-icon-container">
            <IonIcon icon={timeOutline} className="warning-main-icon" />
          </Box>

          {/* Título y mensaje */}
          <Typography level="h4" className="warning-title">
            Tu sesión está a punto de expirar
          </Typography>
          
          <Typography className="warning-message">
            Por motivos de seguridad, tu sesión se cerrará automáticamente si no hay actividad.
          </Typography>

          {/* Contador regresivo */}
          <Box className="countdown-container">
            <Box className="countdown-circle">
              <Typography className="countdown-time">
                {formatTimeLeft}
              </Typography>
            </Box>
            <Typography className="countdown-label">
              Tiempo restante
            </Typography>
          </Box>

          {/* Información adicional */}
          <Box className="info-box">
            <Typography level="body-sm" className="info-text">
              • Se detectó inactividad por más de 4 minutos<br/>
              • La sesión se cerrará automáticamente en {formatTimeLeft}<br/>
              • Tus datos no guardados se perderán
            </Typography>
          </Box>

          {/* Botones de acción */}
          <Box className="action-buttons">
            <IonButton 
              expand="block" 
              fill="solid" 
              color="success"
              onClick={onExtendSession}
              className="extend-button"
            >
              <IonIcon icon={refreshOutline} slot="start" />
              Continuar Sesión
            </IonButton>
            
            <IonButton 
              expand="block" 
              fill="outline" 
              color="danger"
              onClick={onForceLogout}
              className="logout-button"
            >
              <IonIcon icon={logOutOutline} slot="start" />
              Cerrar Sesión Ahora
            </IonButton>
          </Box>
        </Box>
      </IonContent>
    </IonModal>
  );
};

export default SessionWarningModal;